import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

const t = (key, fallback = '') => (window.SPRAGA_I18N && SPRAGA_I18N[key]) || fallback || key;

jQuery(function ($) {
    // phone
    const phoneInputID = "#phone_number";
    let iti = null;
    let lastRawNumber = "";

    function initPhoneInput() {
        const input = document.querySelector(phoneInputID);

        if (input && !input.classList.contains("iti-loaded")) {
            input.classList.add("iti-loaded");

            iti = intlTelInput(input, {
                initialCountry: spraga_obj.default_country,
                separateDialCode: true,
                strictMode: true,
                customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
                    if (!selectedCountryPlaceholder) return "";
                    let placeholder = selectedCountryPlaceholder;


                    if (selectedCountryData.iso2 === 'bg' && placeholder.startsWith('0')) {
                        placeholder = placeholder.substring(1).trim();
                    }
                    return "e.g. " + placeholder;
                },
                geoIpLookup: function (callback) {
                    fetch("https://ipapi.co/json")
                        .then((res) => res.json())
                        .then((data) => callback(data.country_code))
                        .catch(() => callback("bg"));
                },
                loadUtils: () => import("intl-tel-input/utils"),
            });

            input.addEventListener('input', function () {
                const countryData = iti.getSelectedCountryData();
                const dialCode = countryData.dialCode;
                let val = input.value;


                if (val.startsWith('+' + dialCode)) {
                    val = val.substring(dialCode.length + 1).trim();
                } else if (val.startsWith(dialCode)) {
                    val = val.substring(dialCode.length).trim();
                }


                input.value = val.replace(/[^\d\s-]/g, '');
                lastRawNumber = val;
            });

            const updateMaxLength = () => {
                const placeholder = input.getAttribute("placeholder") || "88 123 4567";
                const len = placeholder.replace(/\D/g, '').length + 4;
                input.setAttribute("maxlength", len);
            };

            input.addEventListener('countrychange', updateMaxLength);
            setTimeout(updateMaxLength, 1000);
        }
    }

    initPhoneInput();

    $(document.body).on('updated_checkout', () => {
        initPhoneInput();
    });


    // Init jQuery Validation for edit-account forms
    function initAuthFormsValidation() {
        // If jQuery Validation plugin is not loaded – do nothing
        if (typeof $.fn.validate !== 'function') {
            return;
        }

        // edit account
        var $loginForm = $('form.woocommerce-EditAccountForm.edit-account');
        if ($loginForm.length && !$loginForm.data('validator')) {
            // Disable native browser validation
            $loginForm.attr('novalidate', 'novalidate');

            $loginForm.validate({
                // Use span as error element
                errorElement: 'span',
                errorClass: 'woocommerce-input-error',
                rules: {
                    account_first_name: "required",
                    account_last_name: "required",
                    account_display_name: "required",
                    account_email: "required",
                },
                messages: {
                    account_first_name: t("enter_your_first_name", "Please enter your first name."),
                    account_last_name: t("enter_your_last_name", "Please enter your last name."),
                    account_display_name: t("enter_your_display_name", "Please enter your display name."),
                    account_email: t("enter_your_email", "Please enter your email."),
                },


                // Place error messages for inputs except checkbox/radio
                errorPlacement: function (error, element) {
                    // Skip messages for checkboxes & radios
                    if (element.is(':checkbox') || element.is(':radio')) {
                        return;
                    }

                    error.insertAfter(element);
                },

                // Remove error element from DOM when field becomes valid
                success: function (label, element) {
                    const $el = $(element);

                    // Skip checkboxes/radios
                    if ($el.is(':checkbox') || $el.is(':radio')) {
                        return;
                    }

                    // Completely remove error span from DOM
                    $(label).remove();
                }
            });
        }

    }

    initAuthFormsValidation();

    function initAddressesFormValidation() {
        if (typeof jQuery.fn.validate !== 'function') return;

        const $form = jQuery('form.woocommerce-EditAddressForm.spraga-addresses-form');

        if (!$form.length || $form.data('validator')) return;

        $form.attr('novalidate', 'novalidate');

        $form.validate({
            errorElement: 'span',
            errorClass: 'woocommerce-input-error',

            rules: {
                billing_address_1: "required",
                billing_city: "required",
                billing_postcode: "required",

                shipping_address_1: "required",
                shipping_city: "required",
                shipping_postcode: "required",
            },

            messages: {
                billing_address_1: t("enter_your_street_address", "Please enter your street address."),
                billing_city: t("enter_your_town_or_city", "Please enter your town or city."),
                billing_postcode: t("enter_your_postcode", "Please enter your postcode."),

                shipping_address_1: t("enter_your_street_address", "Please enter your street address."),
                shipping_city: t("enter_your_town_or_city", "Please enter your town or city."),
                shipping_postcode: t("enter_your_postcode", "Please enter your postcode."),
            },

            errorPlacement: function (error, element) {
                if (element.is(':checkbox') || element.is(':radio')) return;
                error.insertAfter(element);
            },

            success: function (label, element) {
                const $el = jQuery(element);
                if ($el.is(':checkbox') || $el.is(':radio')) return;
                jQuery(label).remove();
            }
        });
    }

    initAddressesFormValidation();


    // popup delete account
    $(document).on('shown.bs.modal', function () {
        $('html').css('overflow', 'hidden');
    });
    $(document).on('hidden.bs.modal', function () {
        $('html').css('overflow', '');
    });


    // ajax delete account
    $('#deleteAccountBtn').on('click', function () {
        $.ajax({
            url: spraga_obj.ajax_url,
            type: 'POST',
            data: {
                action: 'delete_user_account',
                nonce: spraga_obj.delete_account_nonce
            },
            success: function (response) {
                if (response.success) {
                    window.location.href = response.data.redirect;
                } else {
                    alert(response.data.message);
                }
            },
            error: function () {
                alert(t("something_went_wrong", "Something went wrong."));
            }
        });
    });

});